import script from "./loading-table.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./loading-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading-table.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./loading-table.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__